// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedBackgroundPanel__container-e144cb {
  width: 360px;
  background-color: var(--addition-100);
  overflow: hidden;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/RoomCallPreviewVideo/AnimatedBackgroundPanel/AnimatedBackgroundPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  width: 360px;\n  background-color: var(--addition-100);\n  overflow: hidden;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AnimatedBackgroundPanel__container-e144cb`
};
module.exports = ___CSS_LOADER_EXPORT___;
